import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  IconButton,
  Typography,
  Dialog,
  CardMedia,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ChevronLeft, ChevronRight, ZoomIn } from "@material-ui/icons";
import { getPhoto, getPhotoUrl } from "../../utils/fileUtils";

const useStyles = makeStyles((theme) => ({
  media: {
    marginTop: theme.spacing(1),
    width: "100%",
    height: "auto",
    maxHeight: "20em",
    borderRadius: 6,
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)",
    cursor: "pointer",
  },
  mediaFull: {
    width: "100%",
    height: "auto",
    borderRadius: 6,
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)",
  },
  // mediaFull: {
  //   margin: "0 auto 0",
  //   width: "auto",
  //   maxWidth: "100%",
  //   height: "auto",
  //   borderRadius: 6,
  //   boxShadow: "0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)",
  // },
  navControls: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
}));

export const PhotoViewer = ({ photos }) => {
  const classes = useStyles();
  const ref = useRef(null);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [photo, setPhoto] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  // const location = useLocation(); // used to force refresh photos on every visit.
  // useEffect(() => {
  //   if (photos?.length > 0 && imgRef.current) {
  //     setSelectedPhoto(photos[0].key);
  //     getPhoto(photos[0].key, setPhoto, imgRef.current.clientWidth);
  //   }
  // }, [imgRef, photos, location.key]);

  useEffect(() => {
    if (photos?.length > 0 && ref.current) {
      const key = photos[photoIndex]?.key;
      getPhoto(key, setPhoto, ref.current.clientWidth);
    }
  }, [photoIndex, photos]);

  const handlePrev = () => {
    if (photoIndex > 0) {
      setPhotoIndex(photoIndex - 1);
    }
  };

  const handleNext = () => {
    if (photoIndex < photos.length - 1) {
      setPhotoIndex(photoIndex + 1);
    }
  };

  const handleMagnifyPhoto = () => {
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
  };

  if (!photos || !photos.length) return null;

  return (
    <Grid item xs={12} ref={ref}>
      <Typography variant="overline" color="textSecondary">
        Photos
      </Typography>
      <CardMedia
        component="img"
        image={photo}
        className={classes.media}
        onClick={handleMagnifyPhoto}
      />
      <div className={classes.navControls}>
        <IconButton onClick={handlePrev} disabled={photoIndex === 0}>
          <ChevronLeft />
        </IconButton>
        <Typography variant="caption">
          Photo {photoIndex + 1} of {photos.length}
        </Typography>
        <div>
          <IconButton onClick={handleMagnifyPhoto}>
            <ZoomIn />
          </IconButton>
          <IconButton
            onClick={handleNext}
            disabled={photoIndex === photos.length - 1}
          >
            <ChevronRight />
          </IconButton>
        </div>
      </div>

      <Dialog open={isOpen} onClose={closeDialog} maxWidth="xl">
        <img
          src={getPhotoUrl(photos[photoIndex]?.key, window.innerWidth)}
          alt={`${photoIndex + 1}`}
          className={classes.mediaFull}
          onClick={closeDialog}
        />
      </Dialog>
    </Grid>
  );
};
